<div style="max-width: 585px;">
<h1 mat-dialog-title i18n="@@input-dialog-example.title" oneDialogTitle>Import Recipient List</h1>
<div mat-dialog-content oneDialogContent class="import-dialog-content">
 
  <p>1. Upload your contact file in .xlsx or .csv format (maximum size: 15 MB):</p>
  <dl-file-upload (dataToSendImportComp)="onFileUpload($event)" ></dl-file-upload>
  <!-- This will be part of future release -->
  <!-- <mat-checkbox class="import-file-contains-checkbox">
    The file contains headers
  </mat-checkbox> -->

  <p style="width:553px">2. Choose a name for your source (this name will be shown in your recipients list overview):</p>
  <mat-form-field appearance="fill" class="source-name-txt-box" oneFormField >    
    <mat-label>Source name</mat-label>
    <input matInput [formControl]="filename" maxlength="25"  dlinputvalidation />
    <button mat-icon-button one-icon-button matSuffix (click)="filename.setValue('')">
      <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix>clear </mat-icon>
    </button>
  </mat-form-field>
  <div class = "import-source-msg">
    <span>
      Characters A-Z and a-z
    </span>
    <span>
     {{filename.value.length}}/25
    </span>
  </div>
  <!-- <div *ngIf="filename.invalid && (filename.dirty || filename.touched)"
  class="alert alert-danger" >
<div *ngIf="filename.errors?.required" style="color: red;">
  Name is required.
</div>
<div *ngIf="filename.errors?.minlength" style="color: red;">
  Name must content atleast 1 charector.
</div> 
<div *ngIf="filename.errors?.pattern" style="color: red;">
  Name must be complete with A-Z a-z.
</div> 
</div> -->
 
 <dl-import-dialog-table ></dl-import-dialog-table>
</div>
<div mat-dialog-actions oneDialogActions class="import-dialog-actions">
  <button
    one-secondary-button
    mat-stroked-button     
     [mat-dialog-close]="true"
  > Cancel
  </button>
 <button color="primary" [disabled]="importButton" [mat-dialog-close]="data"  mat-flat-button i18n="@@input-dialog-example.ok-btn" >
    Import
  </button>
</div>
</div>
